import { mixpanel } from '@fiverr-private/obs';

export const sendMixPanelEvent = ({ eventName, eventData = {} }) => {
    mixpanel.track(eventName, eventData);
};
